import jQuery from "jquery";
import Constants from "../Constants";
import CW from "../services/CW";

export default  (() => {    

    return {
        marketoLandingPageMarker: "LANDING_PAGE__",
	    marketoLandingPageTitleMarker: "__TITLE",
        marketoLandingPageMetaMarker: "__META_DESCRIPTION",
        marketoLandingPageKeywordsMarker: "__KEYWORDS",
        marketoEmailMarker: "EMAIL__",
	    marketoAltTextMarker: "_ALT",
        marketoTextMarker: "__Text",
        marketoDefaultTextMarker: "__Text__default",
	    marketoSubjectMarker: "__Subject",
	    marketoFromNameMarker: "__From+Name",
        marketoFromEmailMarker: "__From+Email",
        marketoReplyToMarker: "__Reply-to",

        marketoRestLandingPageMarker: "LANDING_PAGE__",
        marketoRestLandingPageTitleMarker: "__TITLE",
        marketoRestLandingPageMetaMarker: "__META_DESCRIPTION",
        marketoRestLandingPageKeywordsMarker: "__KEYWORDS",
        marketoRestLandingPageVariableMaker:"LandingPage_Variable_",
        marketoRestEmailMarker: "EMAIL__",
        marketoRestAltTextMarker: "_text",
        marketoRestTextMarker: "__text",
        marketoRestSubjectMarker: "__SUBJECT",
        marketoRestFromNameMarker: "__FROMNAME",
        marketoRestFromEmailMarker: "__FROMEMAIL",
        marketoRestReplyToMarker: "__REPLYTOMAIL",
        marketoRestEmailVariableMaker: "Email_Variable_",
        marketoRestTokenMarker: "TOKEN__",
        marketoRestScriptTokenMarker: "__script block",
        marketoRestSnippetMarker: "SNIPPET__",
        marketoRestFormMarker: "FORM__",
        marketoRestFormLabelMarker: "Label",
        marketoRestFormButtonLabelMarker: "ButtonLabel",
        marketoRestFormWaitingLabelMarker: "WaitingLabel",
        marketoRestFormValidationMessageMarker: "ValidationMessage",
        marketoRestFormHintText: "hintText",
        marketoRestFormText: "Text",
        marketoRestFormFieldValue: "fieldValue",
        marketoRestFormFieldLabel: "fieldLabel",

        eloquaEmailMarker: "EMAIL__",
        eloquaEmailHeaderMarker: "EMAIL_HEADER__",
        eloquaEmailFooterMarker: "EMAIL_FOOTER__",
        eloquaEmailSubjectMarker: "__subject",
        exactTargetEmailMarker: "EMAIL__",
        exactTargetEmailSubjectMarker: "__subject",
        exactTargetEmailHtmlTextMarker: "__html",
        exactTargetEmailAltTextMarker: "__text",
        tokenDefaultMarker: ":default=",
	    tagBody: '(?:[^"\'>]|"[^"]*"|\'[^\']*\')*',
		tokenizeSegmentContent: function(content, projectContentType) {
            var icu = this;
		    if(this.tagOrComment == null) {
		        // Regex from here:  http://stackoverflow.com/questions/295566/sanitize-rewrite-html-on-the-client-side
                this.tagOrComment = new RegExp('(<(?:' + '!--(?:(?:-*[^->])*--+|-?)' + '|script\\b' + this.tagBody +
                   '>[\\s\\S]*?</script\\s*' + '|style\\b' + this.tagBody + '>[\\s\\S]*?</style\\s*' + '|/?[a-z]' + this.tagBody + ')>)', 'gi');
		    }
		    if(this.tagMatcher == null) {
                this.tagMatcher = new RegExp('<([^>]+)>');
		    }
            var results = [];
            // we need to keep track of the last snippet to know if we have multiple tags in a row
            var lastSnippet;
            var priorTagCount = 0;

            CW.crossBrowserRegexSplit(content, this.tagOrComment).forEach(function(snippet, posit) {
                var tokenizedSnippet = [];
                var tokenizedSnippetForEloqua = [];
                if((projectContentType == "MARKETO") || (projectContentType == "ELOQUA") || (projectContentType == "EXACTTARGET")) {
                    var regex;
                    var startDelimiter;
                    var endDelimiter;
                    var startReplace = "";
                    if(projectContentType == "MARKETO") {
                        regex = /(?={{)(.*?)}}/gi;
                        startDelimiter = "{{";
                        startReplace = "";
                        endDelimiter = "}}";
                    } else if (projectContentType == "ELOQUA") {
                        //enabling support for field merge and/or dynamic content in subject line of email
                        var regexForFieldMerge = Constants.FIELD_MERGE_REGEX;
                        var regexForDynamicContent = Constants.DYNAMIC_CONTENT_REGEX;
                        var snippetsSeparatedByFieldMerge = snippet.split(regexForFieldMerge);                        
                        snippetsSeparatedByFieldMerge.forEach(function (tSnippetSegment) {
                            if(tSnippetSegment.includes(Constants.DYNAMIC_CONTENT_START_DELIMITER)) {
                                var snippetsSeparatedByDynamicContent = tSnippetSegment.split(regexForDynamicContent);
                                if(snippetsSeparatedByDynamicContent.length > 1) {
                                    tokenizedSnippetForEloqua = icu.fetchTokenizedSnippetsForDynamicContent(snippetsSeparatedByDynamicContent, tokenizedSnippetForEloqua);
                                }
                            } else {
                                if(snippetsSeparatedByFieldMerge.length > 1) {
                                    var isToken = false;
                                    if (tSnippetSegment.indexOf(Constants.UNDERSCORE_DELIMITER) === 0) {
                                        isToken = true;
                                        tSnippetSegment = Constants.FIELD_MERGE_START_DELIMITER + tSnippetSegment + Constants.FIELD_MERGE_END_DELIMITER;
                                    }
                                    if (tSnippetSegment.length > 0) {
                                        tokenizedSnippetForEloqua.push({
                                            text: tSnippetSegment,
                                            isToken: isToken
                                        })
                                    }
                                }
                            }
                        });
                    } else if (projectContentType == "EXACTTARGET") {
                        regex = /(%%.*?%%)/gi;
                        startDelimiter = "%%";
                        startReplace = "";
                        endDelimiter = "%%";
                    }
                    var tSnippet = snippet.split(regex);
                    if(tSnippet.length > 1) {
                        tSnippet.forEach(function(snippetSegment) {
                            var isToken = false;
                            if(snippetSegment.indexOf(startDelimiter) == 0) {
                                isToken = true;
                                snippetSegment = startReplace + snippetSegment + endDelimiter;
                            }
                            if(snippetSegment && snippetSegment.length > 0) {
                                tokenizedSnippet.push({
                                    text: snippetSegment,
                                    isToken: isToken
                                });
                            }
                        });
                    }
                }

                if((snippet != null) && (snippet.length > 0)) {
                	// If several tags happen in a row, we don't want to show them all, because it's usually something like the end of one tag and the start of another
                	// So we'll keep track of how many tags in a row we've seen
                	var isPreviousElementTag = (lastSnippet != null) ? (lastSnippet.isTag) : false;
                	if(!isPreviousElementTag) {
                		priorTagCount = 0;
                	} else {
						priorTagCount++;
                	}

                	var finalTokenizedSnippet = [];
                	if(tokenizedSnippetForEloqua!=="") {
                	    finalTokenizedSnippet = tokenizedSnippetForEloqua;
                    } else {
                        finalTokenizedSnippet = (tokenizedSnippet.length > 0) ? tokenizedSnippet : null;
                    }

                    var result = {
                        text: snippet,
                        emptyText: (!snippet.trim()),
                        tokenizedSnippet: finalTokenizedSnippet,
                        isTag: icu.tagMatcher.test(snippet),
                        priorTagCount: priorTagCount,
                        projectContentType: projectContentType
                    };

                    results.push(result);
                    lastSnippet = result;
                }
            });

            return results;
		},
        fetchTokenizedSnippetsForDynamicContent : function(tSnippet, tokenizedSnippetForEloqua) {
            tSnippet.forEach(tSnippet, function (tSnippetSegment) {
                var isToken = false;
                if(tSnippetSegment.indexOf(Constants.UNDERSCORE_DELIMITER) == 0) {
                    isToken = true;
                    tSnippetSegment = Constants.DYNAMIC_CONTENT_START_DELIMITER + tSnippetSegment + Constants.DYNAMIC_CONTENT_END_DELIMITER;

                }
                if(tSnippetSegment.length > 0) {
                    tokenizedSnippetForEloqua.push({
                        text: tSnippetSegment,
                        isToken: isToken
                    })
                }
            });
            return tokenizedSnippetForEloqua;
        },
		annotateMarketoSegment: function(segment) {
			 if(!segment.resname) { return; }
		     if (segment.resname.indexOf(this.marketoLandingPageMarker) == 0) {
		         if (segment.resname.indexOf(this.marketoLandingPageTitleMarker, segment.resname.length - this.marketoLandingPageTitleMarker.length) !== -1) {
                    segment.isLPTitle = true;
		         } else if (segment.resname.indexOf(this.marketoLandingPageKeywordsMarker, segment.resname.length - this.marketoLandingPageKeywordsMarker.length) !== -1) {
                    segment.isLPKeyword = true;
		         } else if (segment.resname.indexOf(this.marketoLandingPageMetaMarker, segment.resname.length - this.marketoLandingPageMetaMarker.length) !== -1) {
                    segment.isLPMeta = true;
                 }
		     } else if (segment.resname.indexOf(this.marketoEmailMarker) == 0) {
                 if (segment.resname.indexOf(this.marketoAltTextMarker, this.marketoAltTextMarker.length) > 0) {
                     segment.isAltText = true;
                 } else if (segment.resname.indexOf(this.marketoTextMarker, this.marketoTextMarker.length) > 0) {
                     segment.isText = true;
                 } else if (segment.resname.indexOf(this.marketoSubjectMarker, this.marketoSubjectMarker.length) > 0) {
                     segment.isSubject = true;
                 } else if (segment.resname.indexOf(this.marketoFromNameMarker, this.marketoFromNameMarker.length) > 0) {
                     segment.isFromName = true;
                 } else if (segment.resname.indexOf(this.marketoFromEmailMarker, this.marketoFromEmailMarker.length) > 0) {
                     segment.isFromEmail = true;
                 } else if (segment.resname.indexOf(this.marketoReplyToMarker, this.marketoReplyToMarker.length) > 0) {
                     segment.isReplyTo = true;
                 }	else {
                     segment.isHtmlText = true;
                 }
		     }
		},
        annotateMarketoRestSegment: function (segment) {
            if (!segment.resname) {
                return;
            }
            if (segment.resname.indexOf(this.marketoRestLandingPageMarker) == 0) {
                if (segment.resname.indexOf(this.marketoRestLandingPageTitleMarker, segment.resname.length - this.marketoRestLandingPageTitleMarker.length) !== -1) {
                    segment.isLPTitle = true;
                } else if (segment.resname.indexOf(this.marketoRestLandingPageKeywordsMarker, segment.resname.length - this.marketoRestLandingPageKeywordsMarker.length) !== -1) {
                    segment.isLPKeyword = true;
                } else if (segment.resname.indexOf(this.marketoRestLandingPageMetaMarker, segment.resname.length - this.marketoRestLandingPageMetaMarker.length) !== -1) {
                    segment.isLPMeta = true;
                } else if (segment.resname.indexOf(this.marketoRestLandingPageVariableMaker, this.marketoRestLandingPageVariableMaker.length) > 0) {
                    segment.isLPVariable = true;
                }else {
                    segment.isHtmlText = true;
                }
            } else if (segment.resname.indexOf(this.marketoRestEmailMarker) == 0) {
                if (segment.resname.indexOf(this.marketoRestSubjectMarker, this.marketoRestSubjectMarker.length) > 0) {
                    segment.isSubject = true;
                } else if (segment.resname.indexOf(this.marketoRestFromNameMarker, this.marketoRestFromNameMarker.length) > 0) {
                    segment.isFromName = true;
                } else if (segment.resname.indexOf(this.marketoRestFromEmailMarker, this.marketoRestFromEmailMarker.length) > 0) {
                    segment.isFromEmail = true;
                } else if (segment.resname.indexOf(this.marketoRestReplyToMarker, this.marketoRestReplyToMarker.length) > 0) {
                    segment.isReplyTo = true;
                }else if (segment.resname.indexOf(this.marketoRestEmailVariableMaker, this.marketoRestEmailVariableMaker.length) > 0) {
                    segment.isEmailVariable = true;
                } else if (segment.resname.endsWith(this.marketoDefaultTextMarker) || segment.resname.endsWith(this.marketoTextMarker)){
                    segment.isAltText = true;
                } else {
                    segment.isHtmlText = true;
                }
            } else if (segment.resname.indexOf(this.marketoRestSnippetMarker) == 0) {
                segment.isSnippet = true;
            } else if ( segment.resname.indexOf(this.marketoRestTokenMarker) == 0) {
                segment.isToken = true;
                if(segment.resname.indexOf(this.marketoRestScriptTokenMarker, this.marketoRestScriptTokenMarker.length) > 0){
                    segment.isScriptToken = true;
                }
            } else if ( segment.resname.indexOf(this.marketoRestFormMarker) == 0) {
                if (segment.resname.indexOf(this.marketoRestFormWaitingLabelMarker, this.marketoRestFormWaitingLabelMarker.length) > 0) {
                    segment.isFormWaitingLabel = true;
                } else if (segment.resname.indexOf(this.marketoRestFormButtonLabelMarker, this.marketoRestFormButtonLabelMarker.length) > 0) {
                    segment.isFormButtonLabel = true;
                } else if (segment.resname.indexOf(this.marketoRestFormHintText, this.marketoRestFormHintText.length) > 0) {
                    segment.isFormHintText = true;
                } else if (segment.resname.indexOf(this.marketoRestFormFieldLabel, this.marketoRestFormFieldLabel.length) > 0) {
                    segment.isFormFiledLabel = true;
                } else if (segment.resname.indexOf(this.marketoRestFormFieldValue, this.marketoRestFormFieldValue.length) > 0) {
                    segment.isFormFieldValue = true;
                } else if (segment.resname.indexOf(this.marketoRestFormLabelMarker, this.marketoRestFormLabelMarker.length) > 0) {
                    segment.isFormLabel = true;
                } else if (segment.resname.indexOf(this.marketoRestFormValidationMessageMarker, this.marketoRestFormValidationMessageMarker.length) > 0) {
                    segment.isFormValidationMessage = true;
                }
            } else {
                segment.isHtmlText = true;
            }
        },
		annotateEloquaSegment: function(segment) {
    		if (segment.resname.indexOf(this.eloquaEmailMarker) == 0) {
                 if (segment.resname.indexOf(this.eloquaEmailSubjectMarker, segment.resname.length - this.eloquaEmailSubjectMarker.length) !== -1) {
                    segment.isSubject = true;
                 }
             } else if (segment.resname.indexOf(this.eloquaEmailHeaderMarker) == 0) {
                segment.isHeader = true;
             } else if (segment.resname.indexOf(this.eloquaEmailFooterMarker) == 0) {
                segment.isFooter = true;
             }
		},
		annotateExactTargetSegment: function(segment) {
    		if (segment.resname.indexOf(this.exactTargetEmailMarker) == 0) {
                 if (segment.resname.indexOf(this.exactTargetEmailSubjectMarker, segment.resname.length - this.exactTargetEmailSubjectMarker.length) !== -1) {
                    segment.isSubject = true;
                 } else if (segment.resname.indexOf(this.exactTargetEmailHtmlTextMarker, segment.resname.length - this.exactTargetEmailHtmlTextMarker.length) !== -1) {
                    segment.isHtmlText = true;
                 } else if (segment.resname.indexOf(this.exactTargetEmailAltTextMarker, segment.resname.length - this.exactTargetEmailAltTextMarker.length) !== -1) {
                    segment.isAltText = true;
                 }
             }
		},
    rebuildTranslationContent: function(translation) {
		    // When a user edits a translation, the tokenizedText array gets updated. This will update the other text fields
		    // in the translation based on that            
		    var newText = "";
		    var newRawText = "";
		    translation.forEach(translation.tokenizedText, function(snippet) {
		        if(snippet.tokenizedSnippet) {
		            snippet.tokenizedSnippet.forEach(function(subSnippet) {
                      newRawText = newRawText + subSnippet.text;
                      newText = newText + subSnippet.text;
		            });
		        } else {
                    newRawText = newRawText + snippet.text;
                    if(!snippet.isTag) {
                        newText = newText + snippet.text;
                    }
		        }
		    });

		    translation.text = newText;
            translation.rawText = newRawText;
		},
		rebuildTextFromTokenizedSnippet: function(tokenizedSnippet) {
		    var icu = this;
		    var result = "";

		    tokenizedSnippet.forEach(function(subSnippet) {

		        if(subSnippet.isToken) {
		            var defaultIndex = subSnippet.text.indexOf(icu.tokenDefaultMarker);
		            if(defaultIndex > 0) {
                        result += subSnippet.text.substring((defaultIndex + icu.tokenDefaultMarker.length), (subSnippet.text.length - 2));
		            } else {
                        result += "";
		            }
		        } else {
                    result += subSnippet.text;
		        }
		    });
		    return result;
		},
		rebuildTextForAllTokenizedSnippets: function(tokenizedText) {
		    var icu = this;
		    tokenizedText.forEach( function(snippet) {
                if(snippet.tokenizedSnippet && (snippet.tokenizedSnippet.length > 0)) {
                    snippet.text = icu.rebuildTextFromTokenizedSnippet(snippet.tokenizedSnippet);
                }
		    });
		},
		encodeContentEditableText: function(inputText, isToken) {
	        if (isToken) {
	            return inputText;
            }
			return inputText.replace(/(\r\n|\n|\r)/gm," ").encodeHTML() || " ";
		},
		doesBrowserRequireManualInContextWheelSupport: function() {
		    // When you use the mouse wheel in Chrome or Safari over the iframe, that event gets propagated up to the enclosing div
		    // and scrolls properly. In firefox and IE, these events stay in the iframe, so we need to handle them manually.
		    return jQuery.browser.msie || jQuery.browser.mozilla;
		},
		doesBrowserRequireBrowserScrollbars: function () {
		    // perfectscrollbar chokes when trying to set scrollTop on a div in IE9. I have no idea why, that method usually works fine
		    // in IE9. So we need this method to let us know to use the browser scrollbars in this case...
		    return ((jQuery.browser.msie) && (parseInt(jQuery.browser.version) <= 9));
		}
    }
})();